import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

export default function ACmsNavigationLink({ title, href }) {
	return (
		<li className="a-cms-navigation">
			<NavLink to={href} href={href} activeClassName="active">
				{title}
			</NavLink>
		</li>
	);
}
ACmsNavigationLink.propTypes = {
	title: PropTypes.string.isRequired,
	href: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.cms-navigation-link.js